function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ExplorerDatabase = /*#__PURE__*/function () {
  function ExplorerDatabase(app, mod) {
    _classCallCheck(this, ExplorerDatabase);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(ExplorerDatabase, [{
    key: "dbname",
    get: function get() {
      return this.mod.dbname;
    }
  }, {
    key: "ensureSchema",
    value: function () {
      var _ensureSchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var columns, rows, existing, _i, _columns, _columns$_i, name, definition, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              columns = [['calculated_total_supply', 'TEXT'], ['utxo_graveyard_treasury_total', 'TEXT']];
              _context.n = 1;
              return this.app.storage.queryDatabase('PRAGMA table_info(blocks)', {}, this.dbname);
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = [];
            case 2:
              rows = _t;
              existing = new Set(rows.map(function (row) {
                return row.name;
              }));
              _i = 0, _columns = columns;
            case 3:
              if (!(_i < _columns.length)) {
                _context.n = 5;
                break;
              }
              _columns$_i = _slicedToArray(_columns[_i], 2), name = _columns$_i[0], definition = _columns$_i[1];
              if (existing.has(name)) {
                _context.n = 4;
                break;
              }
              _context.n = 4;
              return this.app.storage.runDatabase("ALTER TABLE blocks ADD COLUMN ".concat(name, " ").concat(definition), {}, this.dbname);
            case 4:
              _i++;
              _context.n = 3;
              break;
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function ensureSchema() {
        return _ensureSchema.apply(this, arguments);
      }
      return ensureSchema;
    }()
  }, {
    key: "upsertBlockStatistics",
    value: function () {
      var _upsertBlockStatistics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(stats) {
        var sql;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              sql = "INSERT OR REPLACE INTO blocks (\n\t\t\tblock_id,\n\t\t\tblock_hash,\n\t\t\ttreasury,\n\t\t\tgraveyard,\n\t\t\ttotal_fees,\n\t\t\ttotal_fees_new,\n\t\t\ttotal_fees_atr,\n\t\t\ttotal_fees_cumulative,\n\t\t\tavg_total_fees,\n\t\t\tavg_total_fees_new,\n\t\t\tavg_total_fees_atr,\n\t\t\ttotal_payout_routing,\n\t\t\ttotal_payout_mining,\n\t\t\ttotal_payout_treasury,\n\t\t\ttotal_payout_graveyard,\n\t\t\ttotal_payout_atr,\n\t\t\tavg_payout_routing,\n\t\t\tavg_payout_mining,\n\t\t\tavg_payout_treasury,\n\t\t\tavg_payout_graveyard,\n\t\t\tavg_payout_atr,\n\t\t\tavg_fee_per_byte,\n\t\t\tfee_per_byte,\n\t\t\tavg_nolan_rebroadcast_per_block,\n\t\t\tburn_fee,\n\t\t\tdifficulty,\n\t\t\tprevious_block_unpaid,\n\t\t\thas_golden_ticket,\n\t\t\tutxo,\n\t\t\ttotal_supply,\n\t\t\tcalculated_total_supply,\n\t\t\tutxo_graveyard_treasury_total\n\t\t) VALUES (\n\t\t\t$block_id,\n\t\t\t$block_hash,\n\t\t\t$treasury,\n\t\t\t$graveyard,\n\t\t\t$total_fees,\n\t\t\t$total_fees_new,\n\t\t\t$total_fees_atr,\n\t\t\t$total_fees_cumulative,\n\t\t\t$avg_total_fees,\n\t\t\t$avg_total_fees_new,\n\t\t\t$avg_total_fees_atr,\n\t\t\t$total_payout_routing,\n\t\t\t$total_payout_mining,\n\t\t\t$total_payout_treasury,\n\t\t\t$total_payout_graveyard,\n\t\t\t$total_payout_atr,\n\t\t\t$avg_payout_routing,\n\t\t\t$avg_payout_mining,\n\t\t\t$avg_payout_treasury,\n\t\t\t$avg_payout_graveyard,\n\t\t\t$avg_payout_atr,\n\t\t\t$avg_fee_per_byte,\n\t\t\t$fee_per_byte,\n\t\t\t$avg_nolan_rebroadcast_per_block,\n\t\t\t$burn_fee,\n\t\t\t$difficulty,\n\t\t\t$previous_block_unpaid,\n\t\t\t$has_golden_ticket,\n\t\t\t$utxo,\n\t\t\t$total_supply,\n\t\t\t$calculated_total_supply,\n\t\t\t$utxo_graveyard_treasury_total\n\t\t)";
              return _context2.a(2, this.runBlockStatisticsStatement(sql, stats, 'upsertBlockStatistics'));
          }
        }, _callee2, this);
      }));
      function upsertBlockStatistics(_x) {
        return _upsertBlockStatistics.apply(this, arguments);
      }
      return upsertBlockStatistics;
    }()
  }, {
    key: "insertBlockStatistics",
    value: function () {
      var _insertBlockStatistics = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(stats) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2, this.upsertBlockStatistics(stats));
          }
        }, _callee3, this);
      }));
      function insertBlockStatistics(_x2) {
        return _insertBlockStatistics.apply(this, arguments);
      }
      return insertBlockStatistics;
    }()
  }, {
    key: "blockStatisticsParams",
    value: function blockStatisticsParams(stats) {
      return {
        $block_id: stats.block_id,
        $block_hash: stats.block_hash,
        $treasury: stats.treasury,
        $graveyard: stats.graveyard,
        $total_fees: stats.total_fees,
        $total_fees_new: stats.total_fees_new,
        $total_fees_atr: stats.total_fees_atr,
        $total_fees_cumulative: stats.total_fees_cumulative,
        $avg_total_fees: stats.avg_total_fees,
        $avg_total_fees_new: stats.avg_total_fees_new,
        $avg_total_fees_atr: stats.avg_total_fees_atr,
        $total_payout_routing: stats.total_payout_routing,
        $total_payout_mining: stats.total_payout_mining,
        $total_payout_treasury: stats.total_payout_treasury,
        $total_payout_graveyard: stats.total_payout_graveyard,
        $total_payout_atr: stats.total_payout_atr,
        $avg_payout_routing: stats.avg_payout_routing,
        $avg_payout_mining: stats.avg_payout_mining,
        $avg_payout_treasury: stats.avg_payout_treasury,
        $avg_payout_graveyard: stats.avg_payout_graveyard,
        $avg_payout_atr: stats.avg_payout_atr,
        $avg_fee_per_byte: stats.avg_fee_per_byte,
        $fee_per_byte: stats.fee_per_byte,
        $avg_nolan_rebroadcast_per_block: stats.avg_nolan_rebroadcast_per_block,
        $burn_fee: stats.burn_fee,
        $difficulty: stats.difficulty,
        $previous_block_unpaid: stats.previous_block_unpaid,
        $has_golden_ticket: stats.has_golden_ticket,
        $utxo: stats.utxo,
        $total_supply: stats.total_supply,
        $calculated_total_supply: stats.calculated_total_supply,
        $utxo_graveyard_treasury_total: stats.utxo_graveyard_treasury_total
      };
    }
  }, {
    key: "runBlockStatisticsStatement",
    value: function () {
      var _runBlockStatisticsStatement = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(sql, stats, label) {
        var params, res, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              params = this.blockStatisticsParams(stats);
              _context4.p = 1;
              _context4.n = 2;
              return this.app.storage.runDatabase(sql, params, this.dbname);
            case 2:
              res = _context4.v;
              if (!((res === null || res === void 0 ? void 0 : res.changes) > 0)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, {
                success: true
              });
            case 3:
              return _context4.a(2, {
                success: false,
                reason: 'no changes'
              });
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
              console.error("Explorer Database: ".concat(label, " failed"), _t2);
              return _context4.a(2, {
                success: false,
                reason: (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'write failed'
              });
          }
        }, _callee4, this, [[1, 4]]);
      }));
      function runBlockStatisticsStatement(_x3, _x4, _x5) {
        return _runBlockStatisticsStatement.apply(this, arguments);
      }
      return runBlockStatisticsStatement;
    }()
  }, {
    key: "getStatisticsByBlockHash",
    value: function () {
      var _getStatisticsByBlockHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(blockHash) {
        var rows, _t3, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (blockHash) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, null);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return this.app.storage.queryDatabase("SELECT * FROM blocks WHERE block_hash = $block_hash LIMIT 1", {
                $block_hash: String(blockHash)
              }, this.dbname);
            case 2:
              _t3 = _context5.v;
              if (_t3) {
                _context5.n = 3;
                break;
              }
              _t3 = [];
            case 3:
              rows = _t3;
              return _context5.a(2, rows[0] || null);
            case 4:
              _context5.p = 4;
              _t4 = _context5.v;
              console.error('Explorer Database: getStatisticsByBlockHash failed', _t4);
              return _context5.a(2, null);
          }
        }, _callee5, this, [[1, 4]]);
      }));
      function getStatisticsByBlockHash(_x6) {
        return _getStatisticsByBlockHash.apply(this, arguments);
      }
      return getStatisticsByBlockHash;
    }()
  }, {
    key: "getStatisticsByBlockHashes",
    value: function () {
      var _getStatisticsByBlockHashes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var hashes,
          params,
          placeholders,
          sql,
          _args6 = arguments,
          _t5,
          _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              hashes = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : [];
              if (!(!Array.isArray(hashes) || !hashes.length)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, []);
            case 1:
              params = {};
              placeholders = hashes.map(function (hash, index) {
                var key = "$hash".concat(index);
                params[key] = hash;
                return key;
              }).join(', ');
              sql = "SELECT * FROM blocks WHERE block_hash IN (".concat(placeholders, ")");
              _context6.p = 2;
              _context6.n = 3;
              return this.app.storage.queryDatabase(sql, params, this.dbname);
            case 3:
              _t5 = _context6.v;
              if (_t5) {
                _context6.n = 4;
                break;
              }
              _t5 = [];
            case 4:
              return _context6.a(2, _t5);
            case 5:
              _context6.p = 5;
              _t6 = _context6.v;
              console.error('Explorer Database: getStatisticsByBlockHashes failed', _t6);
              return _context6.a(2, []);
          }
        }, _callee6, this, [[2, 5]]);
      }));
      function getStatisticsByBlockHashes() {
        return _getStatisticsByBlockHashes.apply(this, arguments);
      }
      return getStatisticsByBlockHashes;
    }()
  }, {
    key: "insertAddressRows",
    value: function () {
      var _insertAddressRows = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var rows,
          sql,
          inserted,
          skipped,
          i,
          _row$is_longest_chain,
          row,
          params,
          res,
          _args7 = arguments,
          _t7;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              rows = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : [];
              if (!(!Array.isArray(rows) || !rows.length)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, {
                inserted: 0,
                skipped: 0
              });
            case 1:
              sql = "INSERT OR IGNORE INTO addresses (\n\t\t\tpublickey,\n\t\t\ttx_hash,\n\t\t\tblock_hash,\n\t\t\tblock_id,\n\t\t\tis_longest_chain,\n\t\t\trecipient,\n\t\t\tdelta\n\t\t) VALUES (\n\t\t\t$publickey,\n\t\t\t$tx_hash,\n\t\t\t$block_hash,\n\t\t\t$block_id,\n\t\t\t$is_longest_chain,\n\t\t\t$recipient,\n\t\t\t$delta\n\t\t)";
              inserted = 0;
              skipped = 0;
              i = 0;
            case 2:
              if (!(i < rows.length)) {
                _context7.n = 7;
                break;
              }
              row = rows[i];
              params = {
                $publickey: row.publickey,
                $tx_hash: row.tx_hash,
                $block_hash: row.block_hash,
                $block_id: row.block_id,
                $is_longest_chain: (_row$is_longest_chain = row.is_longest_chain) !== null && _row$is_longest_chain !== void 0 ? _row$is_longest_chain : 1,
                $recipient: row.recipient,
                $delta: row.delta
              };
              _context7.p = 3;
              _context7.n = 4;
              return this.app.storage.runDatabase(sql, params, this.dbname);
            case 4:
              res = _context7.v;
              if ((res === null || res === void 0 ? void 0 : res.changes) > 0) {
                inserted += 1;
              } else {
                skipped += 1;
              }
              _context7.n = 6;
              break;
            case 5:
              _context7.p = 5;
              _t7 = _context7.v;
              console.error('Explorer Database: insertAddressRows failed', _t7);
              skipped += 1;
            case 6:
              i++;
              _context7.n = 2;
              break;
            case 7:
              return _context7.a(2, {
                inserted: inserted,
                skipped: skipped
              });
          }
        }, _callee7, this, [[3, 5]]);
      }));
      function insertAddressRows() {
        return _insertAddressRows.apply(this, arguments);
      }
      return insertAddressRows;
    }()
  }, {
    key: "updateAddressLongestChainState",
    value: function () {
      var _updateAddressLongestChainState = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(block_id, block_hash, longest_chain) {
        var params, _t8;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              params = {
                $block_id: Number(block_id) || 0,
                $block_hash: String(block_hash || ''),
                $is_longest_chain: longest_chain ? 1 : 0
              };
              _context8.p = 1;
              _context8.n = 2;
              return this.app.storage.runDatabase("UPDATE addresses\n\t\t\t\t SET is_longest_chain = $is_longest_chain\n\t\t\t\t WHERE block_id = $block_id AND block_hash = $block_hash", params, this.dbname);
            case 2:
              return _context8.a(2, _context8.v);
            case 3:
              _context8.p = 3;
              _t8 = _context8.v;
              console.error('Explorer Database: updateAddressLongestChainState failed', _t8);
              return _context8.a(2, null);
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function updateAddressLongestChainState(_x7, _x8, _x9) {
        return _updateAddressLongestChainState.apply(this, arguments);
      }
      return updateAddressLongestChainState;
    }()
  }, {
    key: "pruneAddressesBeforeBlockId",
    value: function () {
      var _pruneAddressesBeforeBlockId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(cutoff_block_id) {
        var cutoff, _t9;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              cutoff = Number(cutoff_block_id);
              if (!(!Number.isFinite(cutoff) || cutoff <= 0)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, {
                changes: 0
              });
            case 1:
              _context9.p = 1;
              _context9.n = 2;
              return this.app.storage.runDatabase("DELETE FROM addresses WHERE block_id < $cutoff_block_id", {
                $cutoff_block_id: cutoff
              }, this.dbname);
            case 2:
              return _context9.a(2, _context9.v);
            case 3:
              _context9.p = 3;
              _t9 = _context9.v;
              console.error('Explorer Database: pruneAddressesBeforeBlockId failed', _t9);
              return _context9.a(2, null);
          }
        }, _callee9, this, [[1, 3]]);
      }));
      function pruneAddressesBeforeBlockId(_x0) {
        return _pruneAddressesBeforeBlockId.apply(this, arguments);
      }
      return pruneAddressesBeforeBlockId;
    }()
  }, {
    key: "getAddressActivity",
    value: function () {
      var _getAddressActivity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(publickey) {
        var limit,
          boundedLimit,
          _args0 = arguments,
          _t0,
          _t1;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              limit = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : 50;
              if (publickey) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, []);
            case 1:
              boundedLimit = Math.min(Math.max(Math.floor(Number(limit) || 50), 1), 500);
              _context0.p = 2;
              _context0.n = 3;
              return this.app.storage.queryDatabase("SELECT publickey, tx_hash, block_hash, block_id, is_longest_chain, recipient, delta\n\t\t\t\t\t FROM addresses\n\t\t\t\t\t WHERE publickey = $publickey\n\t\t\t\t\t   AND is_longest_chain = 1\n\t\t\t\t\t ORDER BY block_id DESC\n\t\t\t\t\t LIMIT $limit", {
                $publickey: String(publickey),
                $limit: boundedLimit
              }, this.dbname);
            case 3:
              _t0 = _context0.v;
              if (_t0) {
                _context0.n = 4;
                break;
              }
              _t0 = [];
            case 4:
              return _context0.a(2, _t0);
            case 5:
              _context0.p = 5;
              _t1 = _context0.v;
              console.error('Explorer Database: getAddressActivity failed', _t1);
              return _context0.a(2, []);
          }
        }, _callee0, this, [[2, 5]]);
      }));
      function getAddressActivity(_x1) {
        return _getAddressActivity.apply(this, arguments);
      }
      return getAddressActivity;
    }()
  }]);
}();
module.exports = ExplorerDatabase;